module.exports = __webpack_public_path__ + "86b519da6721b33b6117668cc8923c06.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/hand/ball-tennis-racket.png
// module id = 2589
// module chunks = 0